import React, { useContext, useState } from 'react'
import Modal from '../../elem/Modal'
import useModal from '../../wrappers/useModal'
import EditPSAPForm from './EditPSAPForm'
import { PSAPDetailContext } from '../../wrappers/PSAPDetailContext'
import { PSAPContext } from '../../wrappers/PSAPContext'
import { UserContext } from '../../wrappers/UserContext'
import { isSysAdmin } from '../../../utils/user/permissions'

const EditPSAPButton = () => {
    const { PSAP } = useContext(PSAPDetailContext)
    const { setNewObject } = useContext(PSAPContext)
    const { roles } = useContext(UserContext)
    const { isShowing, toggle } = useModal()
    const [response, setResponse] = useState(null)
    const [saving, setSaving] = useState(false)

    if (!isSysAdmin(roles)) {
        return null
    }

    const openModal = () => {
        setResponse(null)
        toggle()
        setNewObject(false)
    }

    const handleSave = (resp) => {
        setResponse(resp)
    }

    const savingPSAP = (status) => {
        setSaving(status)
    }

    const closeForm = () => {
        toggle()
        setNewObject(true)
    }

    const text =
        response && response.ok
            ? 'PSAP details saved successfully!'
            : 'Saving PSAP details failed.'

    return isShowing ? (
        <Modal
            isShowing={isShowing}
            toggle={toggle}
            header={`Edit PSAP: ${PSAP.Name} (${PSAP.Id})`}
            footer={
                !response ? (
                    <>
                        <button
                            type="submit"
                            form="editPSAPForm"
                            className="button solidg"
                            disabled={saving}
                        >
                            Save
                        </button>
                        <button
                            type="button"
                            onClick={toggle}
                            className="button is-outlined"
                        >
                            Cancel
                        </button>
                    </>
                ) : (
                    <button
                        type="button"
                        onClick={closeForm}
                        className="button is-primary"
                    >
                        Ok
                    </button>
                )
            }
            response={response}
            body={
                !response ? (
                    <EditPSAPForm
                        handleSave={handleSave}
                        saving={saving}
                        savingPSAP={savingPSAP}
                    />
                ) : (
                    <p>{text}</p>
                )
            }
        />
    ) : (
        <div className="buttonWrapper">
            <button className="button wg" onClick={openModal}>
                Edit PSAP
            </button>
        </div>
    )
}

export default EditPSAPButton
